module.exports = __webpack_public_path__ + "static/media/cheese-swiss.391172a8.svg";